import { createElement as _createElement } from "react";
import { useState } from 'react';
import Slider from './Slider';
export default function InertiaSlider(props) {
    const [key, setKey] = useState(0);
    const handleResize = (newWidth) => setKey(newWidth);
    return _createElement(Slider, { ...props, key: key, onResize: handleResize });
}
